import React from 'react';
import { Guideline } from '../../types/profileTypes';
import { BaseRequirementCard } from './BaseRequirementCard';
import { getSummaryText } from './utils';

interface ApprovedSubstitutionsCardProps {
  guideline: Guideline;
  index: number;
  onEditClick: () => void;
}

export const ApprovedSubstitutionsCard: React.FC<ApprovedSubstitutionsCardProps> = ({
  guideline,
  index,
  onEditClick
}) => {
  // Type guard to ensure we have the right guideline type
  if (guideline.type !== 'ApprovedSubstitutions') {
    return null;
  }

  const summaryText = getSummaryText(guideline);

  return (
    <BaseRequirementCard
      index={index}
      summaryText={summaryText}
      title={guideline.name}
      requirementTypeLabel="Approved Substitutions for Restricted Text"
      onEditClick={onEditClick}
    />
  );
};
